export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13986.c83da83c.jpg";